// Structured data (schema.org JSON-LD) generators.

const SITE_URL = "https://santusgastroenterologo.it";

const DOCTOR_IMAGE =
  "https://customer-assets.emergentagent.com/job_elite-gastro-santus/artifacts/fwop9lov_Foto_Profilo_Lavoro.png";

const PORTOSCUSO_ADDRESS = {
  "@type": "PostalAddress",
  streetAddress: "Via Giulio Cesare, 63",
  addressLocality: "Portoscuso",
  addressRegion: "SU",
  postalCode: "09010",
  addressCountry: "IT",
};

const CARLOFORTE_ADDRESS = {
  "@type": "PostalAddress",
  streetAddress: "Via Giuseppe Garibaldi, 98 — Studio Benessere e Nutrizione",
  addressLocality: "Carloforte",
  addressRegion: "SU",
  postalCode: "09014",
  addressCountry: "IT",
};

const CAGLIARI_ADDRESS = {
  "@type": "PostalAddress",
  streetAddress: "Via Guido Cavalcanti, 11 — Centro Polispecialistico San Benedetto",
  addressLocality: "Cagliari",
  addressRegion: "CA",
  postalCode: "09134",
  addressCountry: "IT",
};

export function physicianSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Physician",
    "@id": `${SITE_URL}/#physician`,
    name: "Dr. Cristian Santus",
    alternateName: "Dott. Cristian Santus",
    medicalSpecialty: "Gastroenterology",
    image: DOCTOR_IMAGE,
    url: SITE_URL,
    telephone: "+39 353 492 4808",
    email: "santusgastroenterologo@gmail.com",
    priceRange: "€€",
    areaServed: [
      { "@type": "AdministrativeArea", name: "Sardegna" },
      { "@type": "City", name: "Cagliari" },
      { "@type": "City", name: "Portoscuso" },
      { "@type": "City", name: "Carloforte" },
    ],
    availableService: [
      { "@type": "MedicalProcedure", name: "Visita gastroenterologica" },
      { "@type": "MedicalProcedure", name: "Second opinion gastroenterologica" },
      { "@type": "MedicalProcedure", name: "Visita di follow-up" },
      { "@type": "MedicalProcedure", name: "Consulenza dietetico-nutrizionale" },
    ],
    knowsAbout: [
      "Reflusso gastroesofageo",
      "Gastrite",
      "Helicobacter pylori",
      "Sindrome del colon irritabile",
      "Celiachia",
      "Malattie infiammatorie intestinali",
      "Diverticolosi",
      "Fegato grasso",
      "Pancreatite",
    ],
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "5.0",
      reviewCount: "75",
      bestRating: "5",
      worstRating: "1",
    },
    address: [PORTOSCUSO_ADDRESS, CARLOFORTE_ADDRESS, CAGLIARI_ADDRESS],
    location: [
      {
        "@type": "MedicalClinic",
        name: "Studio Dr. Cristian Santus — Portoscuso",
        address: PORTOSCUSO_ADDRESS,
        telephone: "+39 353 492 4808",
      },
      {
        "@type": "MedicalClinic",
        name: "Studio Dr. Cristian Santus — Carloforte (Studio Benessere e Nutrizione)",
        address: CARLOFORTE_ADDRESS,
        telephone: "+39 353 492 4808",
      },
      {
        "@type": "MedicalClinic",
        name: "Studio Dr. Cristian Santus — Cagliari",
        address: CAGLIARI_ADDRESS,
        telephone: "+39 353 492 4808",
      },
    ],
    sameAs: [
      "https://www.miodottore.it/cristian-santus/gastroenterologo/cagliari",
    ],
  };
}

export function faqSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: f.a,
      },
    })),
  };
}

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${SITE_URL}${it.path}`,
    })),
  };
}

export function medicalConditionSchema(title, description) {
  return {
    "@context": "https://schema.org",
    "@type": "MedicalCondition",
    name: title,
    description,
    associatedAnatomy: {
      "@type": "AnatomicalStructure",
      name: "Apparato digerente",
    },
  };
}

export function articleSchema(post) {
  return {
    "@context": "https://schema.org",
    "@type": "MedicalWebPage",
    headline: post.title,
    description: post.excerpt,
    image: post.image,
    datePublished: post.date,
    author: {
      "@type": "Physician",
      name: "Dr. Cristian Santus",
      url: SITE_URL,
    },
    publisher: {
      "@type": "Organization",
      name: "Dr. Cristian Santus",
      logo: {
        "@type": "ImageObject",
        url: DOCTOR_IMAGE,
      },
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `${SITE_URL}/blog/${post.slug}`,
    },
  };
}

export function graphSchema(nodes) {
  return {
    "@context": "https://schema.org",
    "@graph": nodes,
  };
}
